import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { PATHS } from '../../../../../Config/Routing/paths'
import { PageTitle } from '../../../../../Components/PageTitle'
import ArrowBackIcon from '../../../../ClientSettings/icons/ArrowBackIcon'
import injectStyles from 'react-jss'
import { styles } from './styles'
import Button from '@material-ui/core/Button'
import Input from '../../../../../Components/Inputs/Input'
import { SnackBarContext } from '../../../../../Components/SnackBar'
import StyledModal from '../../../../../Components/Modal/StyledModal'
import LoadingIndicator from '../../../../../Components/LoadingIndicator/LoadingIndicator'
import IntegrationsService from '../../../../../Module/IntegrationsService/client'
import usePosthogAnalyticsIntegrations from '../../../hooks/usePosthogAnalyiticsIntegrations'

const AddSwellStore = ({ classes }) => {
  const history = useHistory()
  const runSnackBar = useContext(SnackBarContext)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [fields, setFields] = useState({
    swellClientId: { value: '', error: false },
    swellClientKey: { value: '', error: false },
    storeId: { value: '', error: false },
    storeSecretKey: { value: '', error: false },
  })

  const { emitAnalyticsEvent } = usePosthogAnalyticsIntegrations()

  const onBack = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.integrations}${
        PATHS.integrations.swellStores
      }`,
    )
  }

  const onChange = type => (value, error) => {
    setFields(prev => ({
      ...prev,
      [type]: {
        value,
        error: !value || !!error,
      },
    }))
  }

  const onSubmit = async () => {
    setIsOpenModal(false)
    setIsLoading(true)
    await IntegrationsService.createIntegration({
      storeId: fields.storeId.value.trim(),
      storeSecret: fields.storeSecretKey.value.trim(),
    })
    await new Promise(() => {
      setTimeout(() => {
        onBack()
      }, 1500)
    })
    emitAnalyticsEvent('Partner Connected', {
      type: 'swell',
      storeId: fields.storeId.value,
    })
    setIsLoading(false)
    runSnackBar({
      type: 'success',
      vertical: 'top',
      msg: 'Your store is being synced.',
      paddingTop73: true,
    })
  }
  const onOpenModal = () => {
    if (fields.storeId.value && fields.storeSecretKey.value) {
      setIsOpenModal(true)
    } else {
      setFields(prev => {
        const keys = Object.keys(prev)
        const newData = keys.reduce((acc, key) => {
          acc[key] = {
            ...prev[key],
            error: prev[key].value ? null : 'Required',
          }
          return acc
        }, {})
        return newData
      })
    }
  }

  return (
    <div className={classes.container}>
      <StyledModal
        isOpen={isOpenModal}
        title="Do you allow Promofy to access your Swell store?"
        onClose={() => setIsOpenModal(false)}
        onConfirm={onSubmit}
        confirmLabel="Yes"
      />
      <div className={classes.back} onClick={onBack}>
        <ArrowBackIcon height={12} width={16} color="#4F5B94" />
        Back
      </div>
      <PageTitle className={classes.title}>Add your Swell store key</PageTitle>
      <div className={classes.description}>
        Connect your Swell store to Promofy by{' '}
        <strong>inserting your store key</strong>.
        <br />
        This enables <strong>coupon generation</strong> and automatically syncs
        your revenue data in our dashboard for enhanced campaign tracking.
      </div>
      <div className={classes.subtitle}>Add your keys:</div>
      {isLoading ? (
        <LoadingIndicator style={{ height: '42vh' }} />
      ) : (
        <div className={classes.addKeysWrapper}>
          <div className={classes.addKeysInputsMainWrapper}>
            <div className={classes.inputsRow}>
              <Input
                label="Store ID"
                value={fields.storeId.value}
                additionalError={fields.storeId.error}
                onChange={onChange('storeId')}
                required
                cypress_id="storeId"
                className={classes.customInputHeight}
              />
              <Input
                label="Store Secret Key"
                value={fields.storeSecretKey.value}
                additionalError={fields.storeSecretKey.error}
                onChange={onChange('storeSecretKey')}
                required
                cypress_id="storeSecretKey"
                className={classes.customInputHeight}
              />
            </div>
          </div>
          <Button
            variant="outlined"
            onClick={onOpenModal}
            className={classes.button}
            cypress_id="activateBtn"
          >
            Activate
          </Button>
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(AddSwellStore)
